import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../state/reducers';
import { AssetHit } from '../../../../api/vault/searchEngine/interfaces';
import {
  IProps,
  IStateProps,
} from './interfaces';
import PrePostRollListItem from '../PrePostRollListItem/component';

const PrePostRollList: React.FunctionComponent<IProps> = (props: IProps) => {
  const {
    list,
    selectedItem,
    onItemSelect,
  } = props;

  if (list !== null && !list.length) {
    return (
      <div>
        {'No assets found'}
      </div>
    );
  }

  return (
    <>
      {
        list.map((asset: AssetHit) => (
          <PrePostRollListItem
            asset={asset}
            onSelect={onItemSelect}
            isSelected={selectedItem === null ? false : selectedItem._id === asset._id}
            key={asset._id}
          />
        ))
      }
    </>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  list: state.prePostRollSelection.list,
});

export default connect(
  mapStateToProps,
)(PrePostRollList);
